// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overscroll-behavior: none;
  /* iPad / WebKit */
  touch-action: manipulation;          /* no double-tap-to-zoom, no 300ms tap delay */
  -webkit-tap-highlight-color: transparent;
  -webkit-text-size-adjust: 100%;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
.textLayer {
  position: absolute;
  top: 0;
  left: 0;
  color: transparent;
  line-height: 1;
  white-space: pre;
  cursor: text;
  -webkit-user-select: text;
          user-select: text;
}

.textLayer span {
  position: absolute;
  white-space: pre;
  transform-origin: 0% 0%;
}

.textLayer ::selection {
  background: rgba(0, 0, 255, 0.3);
}

.textLayer .highlight {
  background-color: yellow;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;EAGE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B,WAAW,8CAA8C;EACnF,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE;aACW;AACb;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["html,\nbody,\n#root {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overscroll-behavior: none;\n  /* iPad / WebKit */\n  touch-action: manipulation;          /* no double-tap-to-zoom, no 300ms tap delay */\n  -webkit-tap-highlight-color: transparent;\n  -webkit-text-size-adjust: 100%;\n}\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n.textLayer {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  color: transparent;\r\n  line-height: 1;\r\n  white-space: pre;\r\n  cursor: text;\r\n  user-select: text;\r\n}\r\n\r\n.textLayer span {\r\n  position: absolute;\r\n  white-space: pre;\r\n  transform-origin: 0% 0%;\r\n}\r\n\r\n.textLayer ::selection {\r\n  background: rgba(0, 0, 255, 0.3);\r\n}\r\n\r\n.textLayer .highlight {\r\n  background-color: yellow;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
